import { Component } from 'react';
import { Button } from '@/components/ui/button';

class TopLevelErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Top-level route render failed', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <main className="min-h-screen bg-[#F7F8FA] px-6 py-12 text-[#062B1A]">
          <div className="mx-auto flex min-h-[calc(100vh-6rem)] max-w-xl flex-col items-center justify-center text-center">
            <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-sm ring-1 ring-[rgba(6,43,26,0.08)]">
              <img
                src="/assets/mcc-logo-outlined.png"
                alt="MCC"
                className="h-9 w-9 object-contain"
              />
            </div>
            <h1
              className="text-2xl font-semibold tracking-tight"
              style={{ fontFamily: 'var(--font-display)' }}
            >
              Something went wrong — reload
            </h1>
            <p className="mt-3 text-sm leading-relaxed text-[#062B1A]/65">
              The page hit an unexpected rendering error. Reloading should get
              you back to your workspace.
            </p>
            <Button
              type="button"
              onClick={this.handleReload}
              className="mt-6 bg-[#062B1A] text-white hover:bg-[#041B10]"
            >
              Reload
            </Button>
          </div>
        </main>
      );
    }

    return this.props.children;
  }
}

export default TopLevelErrorBoundary;
